import React from "react";
import { useTranslation } from "react-i18next";
import { FaPalette } from "react-icons/fa";
import { Icon } from "../../../../../components/common/Icon";
import { ChatbotFormData } from "../types";
import WidgetCustomizationBuilder from "../../widget_settings/WidgetCustomizationBuilder";

interface WidgetTabProps {
  formData: ChatbotFormData;
  setFormData: React.Dispatch<React.SetStateAction<ChatbotFormData>>;
}

const WidgetTab: React.FC<WidgetTabProps> = ({
  formData,
  setFormData,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tab-pane-content h-100 d-flex flex-column">
      <WidgetCustomizationBuilder
        companyId={formData.company_id}
        value={
          typeof formData.widget_settings === "string"
            ? (() => {
                try {
                  return JSON.parse(formData.widget_settings || "{}");
                } catch {
                  return {};
                }
              })()
            : formData.widget_settings
        }
        onChange={(nextObj: any) =>
          setFormData((prev) => ({
            ...prev,
            widget_settings: JSON.stringify(nextObj),
          }))
        }
      />
    </div>
  );
};

export default WidgetTab;

